// mutations
export const SET_USER = 'SET_USER'
export const SET_MOUSE_POSITION = 'SET_MOUSE_POSITION'
export const SET_SCROLL_TOP = 'SET_SCROLL_TOP'
export const SET_QUIZ = 'SET_QUIZ'
export const SET_QUIZ_INDEX = 'SET_QUIZ_INDEX'
export const SET_QUALISCORE = 'SET_QUALISCORE'
export const SET_USER_RESPONSES = 'SET_USER_RESPONSES'
export const SET_IS_LOADED = 'SET_IS_LOADED'
export const RESET_USER_RESPONSES = 'RESET_USER_RESPONSES'
